export const REPORT_TYPES = {
  INDIVIDUAL: 'EmployeePerformance',
  AGENCY: 'agency',
  OVERALL: 'overall',
  CONTAINER: 'Container',
  PERFORMANCE_SHIFT: 'ShiftPerformance',
  WORK_PREDICTION: 'WorkPrediction',
};

export const REPORT_TYPE_OPTIONS = [
  {
    label: 'Containers',
    value: REPORT_TYPES.CONTAINER,
    icon: 'box',
  },
  {
    label: 'Agency',
    value: REPORT_TYPES.AGENCY,
    icon: 'users',
  },
  {
    label: 'Agency & Individuals',
    value: REPORT_TYPES.OVERALL,
    icon: 'grid',
  },
  {
    label: 'Shift Performance',
    value: REPORT_TYPES.PERFORMANCE_SHIFT,
    icon: 'bar-chart',
  },
  {
    label: 'Individuals',
    value: REPORT_TYPES.INDIVIDUAL,
    icon: 'user',
  },
  {
    label: 'Work Prediction',
    value: REPORT_TYPES.WORK_PREDICTION,
    icon: 'activity',
  },
];
